import { Theme } from '@mui/material';
import styled from '@emotion/styled';

type ParamsStyle = {
    theme?: Theme;
    invalidPin?: string;
}

type ParamsStyleBackground = {
    theme?: Theme;
    background: string;
}

export const Container = styled.div(
    ({ theme }: ParamsStyle) => `
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    
    @media(min-width: ${theme?.breakpoints.values.md}px) {
       flex-direction: row;
    }
`);

export const ContentBackground = styled.div(
    ({ theme, background }: ParamsStyleBackground) => `
    width: 36%;
    height: 100%;
    display: none;
    position: relative;
    padding: 3.375rem 0;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    border-right: 7.75px solid #97C93D;
    background-image: linear-gradient(0deg, rgba(12, 28, 51, .8), rgba(12, 28, 51, .8)), linear-gradient(195.49deg, rgba(6, 28, 69, .3) 15.91%, rgba(28, 56, 107, .3) 76.51%),
    url('${background}');
 
    background-size: cover;
    background-repeat: no-repeat;
 
    svg {
       width: 100%;
       height: auto;
       max-width: 9.56rem;
    }

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        display: flex;
     }
`);

export const ContentForm = styled.div(
    ({ theme }: ParamsStyle) => `
    width: 100%;
    height: 100%;
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        width: 64%;
    }
`);

export const ContentReactCode = styled.div(
    ({ theme, invalidPin }: ParamsStyle) => `
    margin: -2.75rem 0 .25rem;
    padding-bottom: 2.375rem;

    input[type='number'] {
        -moz-appearance: textfield;
    }
    
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    .react-code-input {
        display: flex !important;
        justify-content: space-between;
    }

    input {
        border: 1px solid ${theme?.palette.primary.main};
    }

    input {
        color: ${invalidPin === 'error' ? theme?.palette.error.main : theme?.palette.primary.main};
        border-color: ${invalidPin === 'error' ? theme?.palette.error.main : theme?.palette.primary.main};
    }

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        margin: -1.625rem 0 0;
        padding-bottom: 1.7rem;
    }
`);


export const ContentNavigate = styled.header(
    ({ theme }: ParamsStyle) => `
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: ${theme?.palette.primary.main};
    width: 100%;
    height: 5.25rem;
    box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12);

    svg {
        position: absolute;
        left: 1.31rem;
        path {
            fill: white;
        }
    }

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        position: absolute;
        width: fit-content;
        top: 2.125rem;
        left: 2.125rem;
        height: auto;
        justify-content: start;
        background-color: white;
        box-shadow: none;

        svg {
            position: relative;
            left: 0;
            
            path {
                fill: ${theme?.palette.primary.main};;
            }
        }
    }
`);

export const LinkExtermal = styled('a')(
    ({ theme }: ParamsStyle) => `
    width: 100%;
    font-size: .9375rem;
    position: relative;
    font-weight: 700;
    color: white;
    display: flex;
    height: 40px;
    border-radius: 5px;
    padding-top: 4px;
    align-items: center;
    justify-content: center;
    color: ${theme?.palette.primary.main};
    border: 2px solid ${theme?.palette.primary.main};
    
    svg {
        position: absolute;
        right: 1.25rem;
        height: 1.2rem;
    }
`);